export const getFilename = (str: string) => {
  const lastIndex = str.lastIndexOf('_');
  return str.substring(lastIndex + 1);
};
